import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8u88bjaqn: FaireProductEntity = {
  token: "p_s8u88bjaqn",
  type: "product",
  name: "Shampoo Bar - Zero Waste, Plastic Free, Vegan, 13 Scents",
  brandToken: "b_ygqtn8344d",
  brandName: "ZWS Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/a0a9ce206d2407bd7e3a9699e2ad59502dfa33d142f00ba877f5d39dcb6fb830.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40613908d212650bf8b2b97a10c0ceb7eae32cf1212fc342be7c4bc0fa033fde.jpeg",
    "https://cdn.faire.com/fastly/58b0e89b93af14bfd67ef5d4ec1fc5b6ea819347e5f7c37332dc739546c4dfe2.jpeg",
    "https://cdn.faire.com/fastly/9afa6d15b6c838f1a0f6e2c8c3ad9477ff91c15f8d8be28db807ef01c25e1f16.png",
    "https://cdn.faire.com/fastly/a684810fb920b7b6b5012cc0f2106306f8d420843c50d01cad4edd93fd19fd6c.jpeg",
    "https://cdn.faire.com/fastly/17be4fcb44da3441f19408c0acd144c03c419aedf0e5060e8a388613eaf0710f.jpeg",
    "https://cdn.faire.com/fastly/86ecaeaa5849891d5e1e8854eb2edf64ddce015ac073220c6831f105d7602022.jpeg",
    "https://cdn.faire.com/fastly/3f9892eb7cb23b9651c9de155b498765bf5d8d75cfe4aa5cfda03126a3644f81.jpeg",
    "https://cdn.faire.com/fastly/54af00ae23881a1a8ec3937fdad9073d9ccb2eb997aa617d3b58c58653fe9f7c.jpeg",
    "https://cdn.faire.com/fastly/f0bee6a66d7ac50d348b05f7e9ace2107ecb3daa6de5036b7be08cc7b47d53cf.jpeg",
    "https://cdn.faire.com/fastly/b64f3caaa805258d1b447165a4227ae2e30baa337a7eb4c54c72e6fd092fcd52.jpeg",
    "https://cdn.faire.com/fastly/07174e2c32b0178cded7b995d64dfc0b32236ced23a55f6e4baf5ec0ce680557.jpeg",
    "https://cdn.faire.com/fastly/372cd157cf8649abe72e04c1d17b2ebe9f88f65ebc9194a67d9b8b9e50127077.jpeg",
    "https://cdn.faire.com/fastly/8173a9407b392df3fa693e08563aa2872d4a4ba8d0e51d40e10f72787b069427.jpeg",
    "https://cdn.faire.com/fastly/a4b1ff000c2f6adfbf21feb0b243c71066d28801a57aed388c84ca0bb3ea4122.jpeg",
    "https://cdn.faire.com/fastly/f0fad55dceece969f3cb37e739b26d6b587fde7439b1362b81d1940d243da0cc.jpeg",
    "https://cdn.faire.com/fastly/f19ebf970770766ce4ae864652b3bc3cc312b2ccdf7e1d2eb5c7144e6bd761d0.jpeg",
    "https://cdn.faire.com/fastly/f85daadf0d3dc580bd6487e8c289b3019491ee87244643fd0e9b8ab2ab5ea88d.jpeg",
    "https://cdn.faire.com/fastly/484ffe01a6152ff760064ed4ae17661b382f7404cbfa12ed73b697dac5ee04f7.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "No matter your hair type, whether it's damaged, greasy, dull, colored, or just in need of the perfect shampoo, we have a Shampoo Bar for you! Our salon-quality, all natural formulas gently cleanse while removing oil, sweat, dirt, product buildup, and environmental pollutants from your hair and scalp. Each one of these Zero Waste Shampoo Bars is infused with serious botanical nutrition leaving hair silky-soft and refreshed.\n\nFor best results, we suggest pairing the Shampoo Bar with our highly moisturizing, smoothing Conditioner Bar. You can extend the life of your bars with our plastic-free soap dish, soap lift, agave soap saver bag, or travel tin.\n\nHandmade in the USA.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:43.738Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
